export default {
    tree: {
        base: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            color: '#212529',
            fontFamily: 'Arial,sans-serif',
            fontSize: '14px',
            paddingLeft: '1.5%',
            width: '99%',
            cursor: 'pointer',
            wordWrap: 'break-word'
        },
        node: {
            base: {
                position: 'relative',
                paddingTop: '1%',
                paddingBottom: '1%',
                paddingLeft: '5%'
            },
            link: {
                cursor: 'pointer',
                position: 'relative',
                padding: '0px 5px',
                display: 'block'
            },
            activeLink: {
                color: 'rgb(229, 0, 0)',
                fontWeight: '300'
            },
            toggle: {
                base: {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginLeft: '-5px',
                    marginTop: '-5px',
                    height: '24px',
                    width: '24px'
                },
                wrapper: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    margin: '-7px 0 0 -7px',
                    height: '14px'
                },
                height: 14,
                width: 14,
                arrow: {
                    fill: '#212529',
                    strokeWidth: 0
                }
            },
            header: {
                base: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    color: '#212529'
                },
                connector: {
                    width: '2px',
                    height: '12px',
                    borderLeft: 'solid 2px black',
                    borderBottom: 'solid 2px black',
                    position: 'absolute',
                    top: '0px',
                    left: '-21px'
                },
                title: {
                    lineHeight: '24px',
                    verticalAlign: 'middle'
                }
            },
            subtree: {
                listStyle: 'none',
                paddingLeft: '19px'
            },
            loading: {
                color: '#E2C089'
            }
        }
    }
};